import { Divider } from "@mui/material";
import HeaderWithFilter from "components/headerwithfilter";
import { State } from "data/reducers/state";
import { AppsActions } from "data/slices/apps";
import { AppsStateProps } from "data/slices/apps/interface";
import keys from "locale/keys";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PURE from "widgets/dashboard/apps";

import { Wrapper } from "../styled.components";

const AppsContainer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { apps, isFetching, isError, fetchedApps } = useSelector<
    State,
    AppsStateProps
  >((state) => state.apps);

  useEffect(() => {
    if (!fetchedApps) {
      dispatch(AppsActions.request());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderWithFilter
        title={t(keys.apps)}
        showFilter={false}
        showBackButton={false}
        showSearchField={false}
      />
      <Divider />
      <Wrapper>
        <PURE apps={apps} isError={isError} isFetching={isFetching} />
      </Wrapper>
    </>
  );
};

export default AppsContainer;
